// src/stores/auth.js
import { defineStore } from 'pinia'
import { jwtDecode } from 'jwt-decode'

const roleLevels = {
  user: 1,
  supervisor: 2,
  manager: 3,
  admin: 4
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: null
  }),
  getters: {
    role: state => state.user?.role?.replace('ROLE_', '').toLowerCase(),
    roleLevel: state => roleLevels[state.user?.role?.replace('ROLE_', '').toLowerCase()] || 0,
    hasMinimumLevel: (state) => {
      return (requiredLevel) => {
        const currentLevel = roleLevels[state.user?.role?.replace('ROLE_', '').toLowerCase()] || 0
        const minLevel = roleLevels[requiredLevel.toLowerCase()] || 999
        return currentLevel >= minLevel
      }
    }
  },
  actions: {
    loginWithToken(token) {
      const payload = jwtDecode(token)
      this.token = token
      this.user = {
        id: payload.sub,
        role: payload.roles?.[0] || 'ROLE_USER'
      }
      localStorage.setItem('token', token)
    },
    loadFromStorage() {
      const token = localStorage.getItem('token')
      if (token) {
        const payload = jwtDecode(token)
        this.token = token
        this.user = {
          id: payload.sub,
          role: payload.roles?.[0] || 'ROLE_USER'
        }
      }
    },
    logout() {
      this.token = null
      this.user = null
      localStorage.removeItem('token')
    }
  }
})

export function isAuthenticated() {
  return !!localStorage.getItem('token');  // Verifica se o token de autenticação existe no localStorage
}